angular.module('zippgo.directives').directive('noAnimate', ['$animate', function($animate) {
	return function(scope, element) {
		$animate.enabled(false, element);
	};
}]);